module.exports = __webpack_public_path__ + "static/img/logo.936cd33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 383
// module chunks = 1